<div class="toast-container" aria-live="polite" aria-atomic="true">
  <div
    *ngFor="let toast of toasts$ | async"
    class="toast-notification"
    [class.toast-notification--success]="toast.type === 'success'"
    [class.toast-notification--error]="toast.type === 'error'"
    role="alert"
  >
    <span class="toast-notification__icon" aria-hidden="true">
      <svg
        *ngIf="toast.type === 'success'"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
          fill="currentColor"
        />
      </svg>
      <svg
        *ngIf="toast.type === 'error'"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" fill="currentColor" />
        <path
          d="M8.5 8.5l7 7M15.5 8.5l-7 7"
          stroke="#b3261e"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </span>
    <span class="toast-notification__message" [innerHTML]="toast.message | safe:'html'"></span>
    <button
      type="button"
      class="toast-notification__close"
      (click)="dismiss(toast.id)"
      aria-label="Close"
    >
      &times;
    </button>
  </div>
</div>
